if (!customElements.get('deferred-media')) {
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      this.poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!this.poster) return;

      this.loadContentHandler = this.loadContent.bind(this);
      this.poster.addEventListener('click', this.loadContentHandler);

      if(this.dataset.preload) {
        this.checkViewportHandler = this.checkViewport.bind(this);

        themeBase.onWindowLoadTrigger(() => {
          ['resize', 'scroll', 'MutationObserverLoaded', 'updateStickySidebar']
            .forEach(event => window.addEventListener(event, this.checkViewportHandler));
          this.checkViewport();
        });
      }
    }

    loadContent() {
      // window.pauseAllMedia();
      if (this.getAttribute('loaded')) return;

      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.media = content.querySelector('video, model-viewer, iframe');
      this.isVideoTag = this.media && this.media.tagName === 'VIDEO';

      const loadeddata = () => {
        if(this.onMediaLoadeddata) this.onMediaLoadeddata();
        this.querySelector('.rvideo-component__poster').remove();
      };

      this.isVideoTag ? this.media.addEventListener('loadeddata', () => loadeddata()) : loadeddata();
      this.setAttribute('loaded', true);
      this.appendChild(this.media).focus();
      if(this.isVideoTag && window.safari && this.media.dataset.src) this.media.src = this.media.dataset.src;
      this.poster.removeEventListener('click', this.loadContentHandler);
    }

    checkViewport() {
      const bound = this.getBoundingClientRect();
      
      if(bound.bottom < -200 || bound.top > themeBase.windowHeight + 200) {
        return;  
      }

      this.loadContent();
      ['resize', 'scroll', 'MutationObserverLoaded', 'updateStickySidebar']
        .forEach(event => window.removeEventListener(event,  this.checkViewportHandler));
    }
  }

  window.DeferredMedia = DeferredMedia;
  customElements.define('deferred-media', DeferredMedia);

  class RvideoComponent extends DeferredMedia {
    constructor() {
      super();
    }

    connectedCallback() {
      let isMediaContentLoaded = false;

      this.onMediaLoadeddata = () => {
        isMediaContentLoaded = true;
      };
      
      themeBase.onWindowLoadTrigger(() => {
        setTimeout(() => {
          if(isMediaContentLoaded) return;
          this.querySelector('.rvideo-component__poster').classList.remove('hidden');
        }, 1000);
      });

      if(this.querySelector('template')) return;
      
      this.initHandlers();
    }

    initHandlers() {
      if(!this.isVideoTag) {
        this.classList.remove('rvideo-component--paused');
        return;
      }

      this.video = this.querySelector('video');

      this.addEventListener('click', () => {
        if (this.video.paused) {
          window.pauseAllMedia();
          this.video.play();
          this.classList.remove('rvideo-component--paused');
        } else {
          this.video.pause();
          this.classList.add('rvideo-component--paused');
        }
      });
    }

    loadContent() {
      super.loadContent();
      this.initHandlers();
    }
  }

  customElements.define('rvideo-component', RvideoComponent);

  scriptController.scripts.push('deferred-media.js');
}